module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-mobile-411x93@2x.24c9334c.webp";